import { Injectable } from '@angular/core';
import {Http, Response} from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { Subject } from 'rxjs/Subject';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import {NgbDatepickerI18n, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { isNull } from 'util';
import { param } from 'jquery';

//http://201.183.238.236:8081/apiAcademico/web
// http://192.168.1.106
//190.108.65.178
//181.188.219.33

//const URL = 'http://181.188.219.33:8081/apiAcademico/web';
//const URL_REPORTE = 'http://181.188.219.33:8083/reportes/';

//const URL = "http://186.4.167.107/apiAcademico/web/app.php"
//const URL = "http://77.237.235.48/apiAcademico/web/app.php"

//const URL_REPORTE = 'http://localhost:8091/';
//const URL_REPORTE = 'http://77.237.235.48:8081/reportes/';

const URL_REPORTE = 'https://disyscorp.net/api/financiero/reportes/';
const URL = 'https://disyscorp.net';


const HEADERS = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const color = [
  '#ff3366',
  '#4680ff',
  '#FC6180',
  '#93BE52',
  '#FFB64D',
  '#ab7967',
  '#39ADB5',
  '#7C4DFF',
  '#FF5370',
  '#6f6f6f'
]


const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mie', 'Ju', 'Vi', 'Sa', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  }
};

@Injectable()
export class I18n {
  language = 'es';
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}

@Injectable()
export class GlobalsService {
  readonly baseAPIUrl: string = URL
  readonly baseTempUrl: String  = URL+'/uploads/temp'
  readonly baseAPIArchivo: string = URL.split('/web')[0]
  readonly baseReptUrl: string = URL_REPORTE
   contadorMensajesNoLeidos : any = 0
}

@Injectable()
export class ApiRestService {
  constructor(private http: Http) { }
  getUsers(): Observable<any> {
    return this.http.get('assets/data/usuarios.json')
                    .map (
                      (response : Response) => response.json()
                    )
  }

  getFacturas(): Observable<any> {
    return this.http.get('assets/data/facturas.json')
                    .map (
                      (response : Response) => response.json()
                    )
  }

}


@Injectable()
export class LoopBackAuth{
  constructor(){}
  save(data : any){
    localStorage.setItem('LoopBackAuth', JSON.stringify(data))
  }

  load(){
    return JSON.parse(localStorage.getItem('LoopBackAuth'))
  }
  remove(){
    localStorage.removeItem('LoopBackAuth')
  }
}

@Injectable()
export class correoService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }

  contadorNoLeidos(){
    let params ={
      token: this.LoopBackAuth.load().token,
      idUsuario:this.LoopBackAuth.load().user.id
    }
    console.log("contadorNoLeidos", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoMensaje/contadorNoLeidos",params, HEADERS)
                    .pipe(
                      map(user =>user),
                      catchError( this.handleError('buscar', null,"shortError"))
                    )
  }

  archivosAdjuntos(id:number){
    return this.http.get<any>(URL+"/correoMensaje/adjuntosMensaje/"+this.LoopBackAuth.load().token+"/"+id)
  }

  deletePapelera(items:any){
    let params ={
      token: this.LoopBackAuth.load().token,
      items:items
    }
    console.log("deletePapelera", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoMensaje/deletePapelera",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('buscar', null,"shortError"))
                    )
  }

  leidoMensaje(id: number, estado:boolean){
    let params ={
      token: this.LoopBackAuth.load().token,
      id:id,
      estado: estado
    }
    console.log("leidoMensaje", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoMensaje/leidoMensaje",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('buscar', null,"shortError"))
                    )
  }

  deleteRemitente(items: any){
    let params ={
      token: this.LoopBackAuth.load().token,
      items:items
    }
    console.log("deleteRemitente", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoMensaje/deleteRemitente",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('buscar', null,"shortError"))
                    )
  }
  estadosMensajes(){
    let params ={
      token: this.LoopBackAuth.load().token,
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoMensaje/estado",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('buscar', null,"shortError"))
                    )
  }

  cambioEstado(matriz:any, idEstado:number){
    let params ={
      token: this.LoopBackAuth.load().token,
      matriz: matriz,
      idEstado: idEstado
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoMensaje/cambioEstado",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('buscar', null,"shortError"))
                    )
  }

  searchMensaje(){
    let params ={
      token: this.LoopBackAuth.load().token,
      idUsuario:  this.LoopBackAuth.load().user.id,
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoMensaje/search",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('buscar', null,"shortError"))
                    )
  }

  findId(idMensaje:number){
    let params ={
      token: this.LoopBackAuth.load().token,
      idMensaje:  idMensaje,
    }
    console.log("FindId", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoMensaje/findId",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('buscar', null,"shortError")))
  }

  createUpdateMensaje(item:any){
    item.de = this.LoopBackAuth.load().user.id
    let params ={
      token: this.LoopBackAuth.load().token,
      item: item
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoMensaje/createUpdate",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('crear', null,"shortError"))
                    )
  }

  deleteMensaje(id:number){
    let params ={
      token: this.LoopBackAuth.load().token,
      id: id
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoMensaje/delete",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('borrar', null,"shortError"))
                    )
  }

  searchGrupo(tipo:number = 0){
    let params ={
      token: this.LoopBackAuth.load().token,
      tipo: tipo
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoGrupo/search",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('buscar', null,"shortError"))
                    )
  }

  searchEstudiante(){
    let params ={
      token: this.LoopBackAuth.load().token,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id,
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoGrupo/searchEstudiante",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('buscar', null,"shortError"))
                    )
  }

  createUpdateGrupo(item:any){
    let params ={
      token: this.LoopBackAuth.load().token,
      item: item
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoGrupo/createUpdate",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('crear', null,"shortError"))
                    )
  }

  deleteGrupo(id:number){
    let params ={
      token: this.LoopBackAuth.load().token,
      id: id
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoGrupo/delete",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('borrar', null,"shortError"))
                    )
  }

  agregarUsuarioGrupo(idGrupo: number, datos:any){
    let params ={
      token: this.LoopBackAuth.load().token,
      idGrupo: idGrupo,
      datos: datos
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoGrupo/agregarUsuario",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('borrar', null,"shortError"))
                    )
  }

  deleteGrupoUsuario(idGrupoUsuario:number){
    let params ={
      token: this.LoopBackAuth.load().token,
      id: idGrupoUsuario,
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/correoGrupo/deleteUsuario",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('borrar', null,"shortError"))
                    )
  }

  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

@Injectable()
export class archivosCompartidosService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }

  contadorDescargas(id:any){
    return this.http.get<any>(URL+"/archivo/contadorDescargas/"+this.LoopBackAuth.load().token+"/"+id)
  }

  extencionesArchivos(){
    return this.http.get<any>(URL+"/archivo/extencionesArchivos/"+this.LoopBackAuth.load().token)
  }


  roles(id:any){
    let params ={
      token: this.LoopBackAuth.load().token,
      id: id
    }

    console.log("searchRol", JSON.stringify(params))
    return this.http.post<any>(URL+"/archivo/roles",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('buscar', null,"shortError"))
                    )
  }
  search(){
    let params ={
      token: this.LoopBackAuth.load().token,
      idUsuario: this.LoopBackAuth.load().user.id
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/archivo/search",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('buscar', null,"shortError"))
                    )
  }

  createUpdateRol(idRol: any, curso:any, idCarpeta:any, nivel:number = 0, permiso:number){
    let params ={
      token: this.LoopBackAuth.load().token,
      idRol: idRol,
      curso: curso,
      idCarpeta: idCarpeta,
      sumaNivel:nivel,
      permiso:permiso
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/archivo/createUpdateRol",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('create', null,"shortError"))
                    )
  }

  deleteRol(id:number){
    let params ={
      token: this.LoopBackAuth.load().token,
      id: id
    }
    console.log("eliminar", JSON.stringify(params))
    return this.http.post<any>(URL+"/archivo/deleteRol",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('delete', null,"shortError"))
                    )
  }
  createUpdate(item: any){
    let params ={
      token: this.LoopBackAuth.load().token,
      item: item
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/archivo/createUpdate",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('create', null,"shortError"))
                    )
  }

  delete(id:number){
    let params ={
      token: this.LoopBackAuth.load().token,
      id: id
    }
    console.log("buscar", JSON.stringify(params))
    return this.http.post<any>(URL+"/archivo/delete",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('delete', null,"shortError"))
                    )
  }
  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

@Injectable()
export class validacionService{

  constructor(
    private http: HttpClient,
    private message: MessageService ,
    private LoopBackAuth :  LoopBackAuth){ }

    public identificacion(tipo:any, identificacion:any){
      /** Tipo Cedula */
      console.log("Datos tipos",tipo,  typeof tipo, identificacion, typeof identificacion)
      if(isNull(identificacion) || isNull(tipo)) return false
      if(tipo == "2"){
        if(identificacion.length !== 10) return false
        if(!(/^[0-9]+$/.test(identificacion))) return false
        return this.cedula(identificacion)
      }
      /** Tipo RUC */
      if(tipo == "1"){
        //console.log("RUC numero -->",identificacion.length)
        console.log("Que paso -->",identificacion)
        if(identificacion.length !== 13) return false
        if(!(/^[0-9]+$/.test(identificacion))) return false
        console.log("cedula *** ", this.cedula(identificacion))
        if(this.cedula(identificacion)) return true;
        return this.ruc(identificacion)
      }
      /** Tipo Pasaporte */
      if(tipo == "3"){
        //console.log("tipo pasaporte -->", identificacion.length)
        //if(identificacion.length < 3) return false
        return true
      }
       /** Tipo Consumidor FInal */
      if(tipo == "4"){
        if(identificacion.length !== 13) return false
        if(!(/^[0-9]+$/.test(identificacion))) return false
        return this.consumidor(identificacion)
      }
      return false
    }

    /** Validar CONSUMIDOR FINAL */
    private consumidor(identificacion:string){
      let bandera = true
      for(let i = 0; i < 12; i++){
        let numero = parseInt(identificacion.substr(i,1))
        if(numero != 9) bandera = false
      }
      return bandera
    }

    /** Validacion MOD 10 */
    private cedula(identificacion:string){
      let sum = 0
      for(let i = 0; i < 9; i++){
        let numero = parseInt(identificacion.substr(i,1))
        if((i+1) % 2 == 0){
          sum = sum + numero
        }else{
          let valor = ( numero * 2 > 9 ) ? (numero * 2) - 9 : numero*2
          sum = sum + valor
        }
      }
      let validador = ((sum % 10) == 0 ) ? 0 : 10 -(sum % 10)
      return (validador == parseInt(identificacion.substr(9,1)))
    }

    /** Switch para validar el RUC por el tipo de consumidor */
    private ruc(identificacion:string){
      let contribuyente = parseInt(identificacion.substr(2,1))

      /** R.U.C. Persona natural */
      if(contribuyente < 6){
        console.log("Contribuyente", contribuyente)
        return this.cedula(identificacion)
      }
      /** R.U.C. Jurídicos y extranjeros sin cédula */
      if(contribuyente == 9){
        return this.mod11(identificacion,"432765432")
      }

      /** R.U.C. Públicos */
      if(contribuyente == 6){
        return this.mod11(identificacion,"32765432")
      }
    }

    /** Validacion con MOD 11 */
    private mod11(identificacion:string, coeficiente:string){
      let sum = 0
      for(let i = 0; i < 9; i++){
        sum = sum + (parseInt(identificacion.substr(i,1)) * parseInt(coeficiente.substr(i,1)))
      }
      let validador = ((sum % 11) == 0 ) ? 0 : 11 - (sum % 11)
      return (validador == parseInt(identificacion.substr(9,1)))
    }

  sizeArchivo(numero: any){
    let valor = numero / 1000
    if(valor < 1 ) return {numero:numero, siglas:'bytes'}
    if(valor > 1 && valor < 1000) return {numero:valor, siglas:'KB'}
    valor = valor / 1000
    if(valor >= 1 && valor < 1000) return {numero:valor, siglas:'MB'}
    valor = valor / 1000
    if(valor >= 1 && valor < 1000) return {numero:valor, siglas:'GB'}
  }
  fechaAJson(fecha : any){
    return {
        year: fecha.getFullYear() ,
        month: fecha.getMonth()+1 ,
        day : fecha.getDate()
      }
  }

  stringHoraAJson(hora:any){
    console.log("Hora -->", hora)
    if(isNull(hora)) return null
    return {
      hour: hora.split(':')[0],
      minute: hora.split(':')[1],
      second:hora.split(':')[2]
    }
  }

  stringFechaAJson(fecha:any){
    if(isNull(fecha)) return null
    let date = new Date(fecha.split('-')[0],(fecha.split('-')[1]-1),fecha.split('-')[2])
    return {
      year: date.getFullYear() ,
      month: date.getMonth()+1 ,
      day : date.getDate()
    }
  }


  jsonAFecha(fecha: any){
    return fecha.year +'-'+ fecha.month + '-'+ fecha.day +' '
  }

  construirArbol(lista){
    let arbol =[]
    this.recorrer(lista, arbol, null, 0)
    console.log("arbol", arbol)
    return arbol
  }

  construirTree(lista, campoPadre){
    let arbol =[]
    this.generarTree(lista, arbol, null, 0, campoPadre)
    return arbol
  }

  private generarTree(lista, rama, padre, nivel, campoPadre){
    let hijos = this.hijos(lista,padre,campoPadre)
    nivel = nivel + 1
    if(hijos.length > 0){
      let count = 0
      for(let hijo of hijos){
        rama.push(this.ramaBasica(hijo, nivel, padre, count))
        //console.log("campo",campoPadre, padre, count, hijo.nodo_id)
        //this.generarTree(lista, rama[count].children, hijo.nodo_id, nivel,campoPadre)
        count ++
        console.log("rama",rama)
      }
    }else{
      return null
    }
  }

  ramaBasica(item,nivel, padre, count){
    return {
      id:item.nodo_id,
      descripcion:item.descripcion,
      nivel: nivel,
      nodoPadreId: padre,
      mostrar: false,
      orden: count,
      children:[],
    }
  }

  iniciales(texto : string){
    if(texto == null || texto ==='') return ''
    let array = texto.split(" ")
    console.log("palabras", array.length, texto)
    if(array.length == 1){
      return texto.slice(0,3)
    }
    if(array.length == 2){
      return array[0].slice(0,2) + array[1].slice(0,1)
    }
    if(array.length >= 3){
      return array[0].slice(0,1) + array[1].slice(0,1) + array[2].slice(0,1)
    }
  }

  buscarNodo(ramas, idNodo, nivel, idNivel){
    nivel = nivel + 1
    let dato = null
    if(ramas.length > 0){
      let index = ramas.findIndex(element => element.id == idNodo)
      if(index >= 0){
        return ramas[index]
      }else{
        for(let rama of ramas){
          dato = this.buscarNodo(rama.children,idNodo, nivel, idNivel)
          if(dato != null) return dato
        }
      }
    }else{
      return null
    }
  }

  construirNotas(arbol, alumnos, calificaciones, pesum, orientacion = 0){
      this.arbolRecorrer(arbol, 0, alumnos, calificaciones, pesum, null, orientacion)
  }

  private arbolRecorrer(ramas,nivel, alumnos, calificaciones, pesum, padre, orientacion = 0 ){
    nivel = nivel + 1
    if(ramas.length > 0){
      let count = 0
      for(let rama of ramas){
        rama.notas = this.notas(alumnos, calificaciones, pesum, rama, padre , orientacion)
        rama.total = this.totalColumna(rama.notas)
        this.arbolRecorrer(rama.children,nivel, alumnos, calificaciones, pesum, rama, orientacion)
      }
    }else{
      return null
    }
  }
  private totalColumna(notas){
    let total = 0.00
    let count = 0
    for(let item of notas){
      if(item.nota != null && item.nota != '-' && item.nota !='' && item.estado_alumno != 'R'){
        total = total + parseFloat(item.nota)
        count ++
      }
    }

    let divisor = (count == 0) ? 1 : count

    //console.log("Valor de notas",divisor, total, (total / divisor ).toFixed(2))
    /** TRUNCA EL VALOR DEL TOTAL */
    /*return (Math.floor((total / divisor ) * 100) / 100).toFixed(2)*/
    /*return (total / divisor ).toFixed(2)*/
    return this.truncateDecimals((total / divisor ),2)
  }

  private truncateDecimals(number:any, digits:any) {
    var multiplier = Math.pow(10, digits),
        adjustedNum = number * multiplier,
        truncatedNum = Math[adjustedNum < 0 ? 'ceil' : 'floor'](adjustedNum);

    return truncatedNum / multiplier;
  };

  private notas(alumnos, calificaciones, pensum, tarea, padre, orientacion = 0){
    let notas = []
    for(let alumno of alumnos){
      let nota = null
      let color = null

      /** Variable orientacion es para saber si estamos en la vista del profesor o del padre */
      if(orientacion == 0){
        nota = calificaciones.filter(x=> x.aca_matricula_id == alumno.aca_matricula_id &&  x.aca_docente_asignatura_curso_id == pensum && x.aca_actividad_id == tarea.id)
        color = calificaciones.filter(x => x.aca_matricula_id == alumno.aca_matricula_id && x.aca_calificacion_id == null )
      }

      if(orientacion == 1){
        nota = calificaciones.filter(x=>  x.aca_docente_asignatura_curso_id == alumno.aca_docente_asignatura_curso_id && x.aca_actividad_id == tarea.id)
        color = calificaciones.filter(x => x.aca_docente_asignatura_curso_id == alumno.aca_docente_asignatura_curso_id && x.aca_calificacion_id == null )
      }

      let promedio_general = calificaciones.filter(x=> x.aca_matricula_id == alumno.aca_matricula_id &&  x.aca_docente_asignatura_curso_id == pensum && x.aca_actividad_tipo_id == 6)
      let promedio_final = calificaciones.filter(x=> x.aca_matricula_id == alumno.aca_matricula_id &&  x.aca_docente_asignatura_curso_id == pensum && x.aca_actividad_tipo_id == 11)

      let estado_promedio_final = true
      if(promedio_final.length > 0 ){
        if (!isNull(promedio_final[0].calificacion) && parseInt(promedio_final[0].calificacion) == 0){
          if(promedio_general.length > 0){
            if(!isNull(promedio_general[0].calificacion) && parseInt(promedio_general[0].calificacion) > 0){
              estado_promedio_final = false
            }
          }
        }
      }

      nota = (nota.length > 0) ? nota[0] : null
      let causaPadre = []
      if(orientacion == 0){
        causaPadre = (padre != null)? padre.notas.filter(x=> x.alumno == alumno.aca_matricula_id) : []
      }

      if(orientacion == 1){
        causaPadre = (padre != null)? padre.notas.filter(x=> x.alumno == alumno.aca_docente_asignatura_curso_id) : []
      }

      let numero_decimal = (orientacion == 1) ?  alumno.numero_decimal : tarea.numero_decimal
      /** Cambio de color de letras para los calculos finales */
      /** Verifico si color de la nota es diferente indefinido */
      if((!isNull(nota) && nota.color == undefined) && tarea.es_actividad_final){
        if(tarea.aca_actividad_tipo_id > 6  && tarea.aca_actividad_tipo_id < 11){
          nota.color ='#829600'
        }else{
          nota.color ='#777'
        }
      }
      /** Inicializo la variable */
      let color_fondo =''
      if(!isNull(tarea.nodoPapa) && tarea.es_actividad_final){
        /** Cambio el color del fondo */
        if(promedio_general.length > 0){
            if(tarea.aca_actividad_tipo_id == 7 && promedio_general[0].rc) color_fondo ='#ffc107'
            if(tarea.aca_actividad_tipo_id == 8 && promedio_general[0].sp) color_fondo ='#a35eff'
            if(tarea.aca_actividad_tipo_id == 9 && promedio_general[0].rm) color_fondo ='#ff6bcd'
            if(tarea.aca_actividad_tipo_id == 10 && promedio_general[0].eg) color_fondo ='#FC6180'
        }
        /** Cambio el color del texto */
        color = {color:'transparent'}
        if(!isNull(nota)){
          //nota.color ='#777'
          if(parseInt(nota.calificacion) > 0 && tarea.es_actividad_final ) nota.color = '#777'
          if(parseInt(nota.calificacion) == 0 && !(tarea.aca_actividad_tipo_id > 6  && tarea.aca_actividad_tipo_id < 11)) nota.color = 'red'
          if(parseInt(nota.calificacion) == 0 && (tarea.aca_actividad_tipo_id > 6  && tarea.aca_actividad_tipo_id < 11)) nota.color = 'transparent'

        }else{
          if(!(tarea.aca_actividad_tipo_id > 6  && tarea.aca_actividad_tipo_id < 11)) color = {color:'red'}
        }
      }
      /** Colo el color rojo si nota no extiste y esta en la raiz principal */
      if(isNull(nota) && isNull(tarea.nodoPapa)){
        color = {color:'red'}
      }
      //if(promedio_general.length > 0 && promedio_general[0].aca_matricula_id == 1059)
        //console.log("Entre al camello -->",promedio_general[0])

      notas.push({
        id: (nota != null) ? nota.aca_calificacion_id : null,
        nota: (nota != null) ?  parseFloat(nota.calificacion).toFixed(numero_decimal) :(orientacion == 1) ? null : 0 ,
        alumno: (orientacion == 1) ? alumno.aca_docente_asignatura_curso_id :alumno.aca_matricula_id,
        descripcion:(orientacion == 1) ? alumno.asignatura :alumno.estudiante,
        aca_docente_asignatura_curso_id: (orientacion == 1) ? alumno.aca_docente_asignatura_curso_id: pensum,
        docente_nombre:(orientacion == 1) ? alumno.docente_nombre: null,
        aca_actividad_id:tarea.id,
        color: (nota != null) ? (nota.color != null)? nota.color: '#777': color.color ,
        observacion:  (nota != null && nota.numero_causa != undefined) ? nota.numero_causa : null,
        observacionPadre: (causaPadre.length > 0)? (causaPadre[0].observacion > 0) ? causaPadre[0].observacion: causaPadre[0].observacionPadre : null,
        numero_decimal: numero_decimal,
        causa_rango_final: (nota != null) ? nota.causa_rango_final : 6.99,
        causa_rango_inicial:(nota != null) ? nota.causa_rango_inicial: 0.01,
        novedad_rango_final: (nota != null) ? nota.novedad_rango_final : 6.99,
        novedad_rango_inicial:(nota != null) ? nota.novedad_rango_inicial: 0.01,
        activar_novedad: (padre != null ) ? padre.ingresa_novedad :false,
        actividad_activa: alumno.actividad_activa,
        calificacion_texto:(nota != null) ? nota.calificacion_texto : null,
        activar_refuerzo_academico:(nota != null) ? nota.activar_refuerzo_academico : 0,
        estado_alumno: alumno.estado,
        eg:(promedio_general.length > 0) ? promedio_general[0].eg : false,
        rc:(promedio_general.length > 0) ? promedio_general[0].rc : false,
        rm:(promedio_general.length > 0) ? promedio_general[0].rm : false,
        sp:(promedio_general.length > 0) ? promedio_general[0].sp : false,
        promedio_final: estado_promedio_final,
        boquea_final: (promedio_general.length > 0)? promedio_general[0].boquea_final: false,
        copiar_calificacion: tarea.copiar_calificacion,
        es_actividad_final: tarea.copiar_calificacion,
        color_fondo:color_fondo,
        tareas:[],
        verTabla:false
      })
    }
    return notas
  }

  private recorrer(lista, rama, padre, nivel){
    let hijos = this.hijos(lista,padre)
    nivel = nivel + 1
    if(hijos.length > 0){
      let count = 0
      let exite_promedio_final = (lista.filter(x=> x.aca_actividad_tipo_id == 11).length > 0) ? true :false
      for(let hijo of hijos){
        rama.push(this.rama(hijo, nivel, padre,exite_promedio_final))
        this.recorrer(lista, rama[count].children, hijo.id, nivel)
        count ++
      }
    }else{
      return null
    }
  }

  private rama(item: any,nivel: any, padre:any, exite_promedio_final:any){
    return {
      id:item.id,
      descripcion:item.descripcion,
      abreviatura:item.abreviatura,
      background:item.aca_curso_completo_id,
      color:  (isNaN(item.color))? item.color: '#959595', //'#1e4f80',
      total: 0,
      modificar:false,
      fecha:"2019-01-09",
      nivel: nivel,
      nodoPapa: padre,
      formula: item.formula,
      children:[],
      notas:[],
      rango_final:item.rango_final,
      rango_inicial: item.rango_inicial,
      tiene_nodo: item.tiene_nodo,
      tiene_tarea: item.tiene_tarea,
      orden:item.orden,
      aca_asignatura_id:item.aca_asignatura_id,
      aca_asignatura_tipo_id: item.aca_asignatura_tipo_id,
      aca_ciclo_periodo_id:item.aca_ciclo_periodo_id,
      aca_curso_completo_id:item.aca_curso_completo_id,
      fecha_tarea: item.fecha_tarea,
      aca_actividad_tipo_id: item.aca_actividad_tipo_id,
      fecha_apertura_docente: item.fecha_apertura_docente,
      fecha_apertura_secretaria: item.fecha_apertura_secretaria,
      fecha_cierre_docente: item.fecha_cierre_docente,
      fecha_cierre_secretaria: item.fecha_cierre_secretaria,
      fecha_final_asistencia: item.fecha_final_asistencia,
      fecha_apertura_docente_causa:item.fecha_apertura_docente_causa,
      fecha_cierre_docente_causa: item.fecha_cierre_docente_causa,
      fecha_inicial_asistencia: item.fecha_inicial_asistencia,
      fecha_apertura_docente_novedad: item.fecha_apertura_docente_novedad,
      fecha_cierre_docente_novedad:item.fecha_cierre_docente_novedad,
      ingresa_causa: item.ingresa_causa,
      ingresa_novedad: item.ingresa_novedad,
      numero_decimal:item.numero_decimal,
      aca_curso_nivel_id: item.aca_curso_nivel_id,
      aca_curso_paralelo_id: item.aca_curso_paralelo_id,
      aca_curso_especialidad_id: item.aca_curso_especialidad_id,
      ver: (nivel == 1) ? true : false,
      exite_promedio_final : exite_promedio_final,
      copiar_calificacion:item.copiar_calificacion,
      es_actividad_final: item.es_actividad_final
    }
  }

  private hijos(lista, padre, campoPadre ='aca_actividad_id'){
    let hijos = [];
    hijos = lista.filter(function(item){
      if(item[campoPadre] == padre){
        return item
      }
    })
    return hijos
  }

  generarColor(i){
    return color[(i <= color.length - 1) ? i : i % 10]
  }

  verlistaBecas(){
    let roles = this.LoopBackAuth.load().user.roles
    for(let item of roles){
      if(item.adm_rol_id != 3 &&  item.adm_rol_id != 1 && item.adm_rol_id != 4)
       return true
    }
    return false
  }


  accsesoTareas(tarea){
    let dateNow = new Date().getTime()
    let date = new Date()
    let dateStart
    let dateEnd
    //console.log("entre ---------------------", this.accesoSeccion('calificaciones'))
    if(this.accesoSeccion('calificaciones') == 5){
      dateStart = new Date(tarea.fecha_apertura_docente).getTime()
      dateEnd = new Date(tarea.fecha_cierre_docente).getTime()
      //console.log("inicio", dateStart,"fin", dateEnd)
      return  (dateNow >= dateStart && dateNow <= dateEnd) ? true : false
    }else if(this.accesoSeccion('calificaciones') == 3 || this.accesoSeccion('calificaciones') == 1){
      dateStart = new Date(tarea.fecha_apertura_secretaria).getTime()
      dateEnd = new Date(tarea.fecha_cierre_secretaria).getTime()
      //console.log("inicio", dateStart,"fin", dateEnd)
      return   (dateNow >= dateStart && dateNow <= dateEnd) ? true : false
    } else{
      console.log("no tengo acceso")
      return false
    }
  }

  accesoCausas(tarea){
    let dateNow = new Date().getTime()
    let activarRol = false

    for(let rol of this.LoopBackAuth.load().user.roles){
      if(rol.adm_rol_id == 3 || rol.adm_rol_id == 1)
        activarRol = true
    }

    if(activarRol){

      if(tarea.fecha_apertura_secretaria != null && tarea.fecha_cierre_secretaria != null){
        let dateStart = new Date(tarea.fecha_apertura_secretaria).getTime()
        let dateEnd = new Date(tarea.fecha_cierre_secretaria).getTime()
        return  (dateNow >= dateStart && dateNow <= dateEnd)? true : false
      }
    }else{
      if(tarea.fecha_apertura_docente_causa != null && tarea.fecha_cierre_docente_causa != null){
        let dateStart = new Date(tarea.fecha_apertura_docente_causa).getTime()
        let dateEnd = new Date(tarea.fecha_cierre_docente_causa).getTime()
        return  (dateNow >= dateStart && dateNow <= dateEnd)? true : false
      }
    }
    return false
  }

  accesoNovedad(tarea){
    let dateNow = new Date().getTime()
    let activarRol = false

    for(let rol of this.LoopBackAuth.load().user.roles){
      if(rol.adm_rol_id == 3 || rol.adm_rol_id == 1)
        activarRol = true
    }

    if(activarRol){

      if(tarea.fecha_apertura_secretaria != null && tarea.fecha_cierre_secretaria != null){
        let dateStart = new Date(tarea.fecha_apertura_secretaria).getTime()
        let dateEnd = new Date(tarea.fecha_cierre_secretaria).getTime()
        return  (dateNow >= dateStart && dateNow <= dateEnd)? true : false
      }
    }else{
      if(tarea.fecha_apertura_docente_novedad != null && tarea.fecha_cierre_docente_novedad != null){
        let dateStart = new Date(tarea.fecha_apertura_docente_novedad).getTime()
        let dateEnd = new Date(tarea.fecha_cierre_docente_novedad).getTime()
        return  (dateNow >= dateStart && dateNow <= dateEnd)? true : false
      }
    }
    return false
  }

  accsesoAsistencia(tarea){
    let dateNow = new Date().getTime()
    let date = new Date()
    let dateStart
    let dateEnd
    return true
    //console.log("entre ---------------------", this.accesoSeccion('calificaciones'))
    /*if(this.accesoSeccion('calificaciones') == 5){
      dateStart = new Date(tarea.fecha_apertura_docente).getTime()
      dateEnd = new Date(tarea.fecha_cierre_docente).getTime()
      //console.log("inicio", dateStart,"fin", dateEnd)
      return  (dateNow >= dateStart && dateNow <= dateEnd) ? true : false
    }else if(this.accesoSeccion('calificaciones') == 3 || this.accesoSeccion('calificaciones') == 1){
      dateStart = new Date(tarea.fecha_apertura_secretaria).getTime()
      dateEnd = new Date(tarea.fecha_cierre_secretaria).getTime()
      //console.log("inicio", dateStart,"fin", dateEnd)
      return   (dateNow >= dateStart && dateNow <= dateEnd) ? true : false
    } else{
      console.log("no tengo acceso")
      return
    }*/
  }

  accesoSeccion(seccion){
    let activar = null
    switch(seccion){
      case 'calificaciones':
        for(let rol of this.LoopBackAuth.load().user.roles){
          if(rol.adm_rol_id == 3 ||  rol.adm_rol_id == 5 || rol.adm_rol_id == 1) activar  = rol.adm_rol_id
        }
        break;
      case 'administrador':
        for(let rol of this.LoopBackAuth.load().user.roles){
          if( rol.adm_rol_id == 1) activar  = rol.adm_rol_id
        }
        break;
      case 'secretaria':
        for(let rol of this.LoopBackAuth.load().user.roles){
          if( rol.adm_rol_id == 3) activar  = rol.adm_rol_id
        }
      break;
      case 'docentes':
        for(let rol of this.LoopBackAuth.load().user.roles){
          if( rol.adm_rol_id == 5) activar  = rol.adm_rol_id
        }
      break;
      case 'inspector':
        for(let rol of this.LoopBackAuth.load().user.roles){
        if( rol.adm_rol_id == 13) activar  = rol.adm_rol_id
        }
      break;
      case 'inspectorGeneral':
      for(let rol of this.LoopBackAuth.load().user.roles){
        if( rol.adm_rol_id == 14) activar  = rol.adm_rol_id
        }
      break;
      case 'autoridades':
      for(let rol of this.LoopBackAuth.load().user.roles){
        if( rol.adm_rol_id == 11) activar  = rol.adm_rol_id
        }
      break;
      case 'colecturia':
      for(let rol of this.LoopBackAuth.load().user.roles){
        if( rol.adm_rol_id == 7) activar  = rol.adm_rol_id
        }
      break;

    }
    return activar
  }
  accesoBecas(){
    let roles = this.LoopBackAuth.load().user.roles
    for(let item of roles){
      if(item.adm_rol_id == 9 )
       return false
    }
    return true
  }

  accsesoMatricula(idEstado, preview){
    if(preview =='true') return true
    let roles = this.LoopBackAuth.load().user.roles
    for(let item of roles){
      if(item.adm_rol_id == 3 || item.adm_rol_id == 1 || item.adm_rol_id == 7)
        return false
      if(item.adm_rol_id == 4 && idEstado < 102)
        return false
    }
    return true
  }
  accesoAcuerdos(idEstado){
    let roles = this.LoopBackAuth.load().user.roles
    for(let item of roles){
      if(item.adm_rol_id == 4 && idEstado < 102)
        return true
    }
    return false
  }

  gruposDefecto(lista,tipo = 1){
     if(lista == null || lista.length == 0) return null
     let defecto;
     defecto = lista.filter(item=> item.defecto == true)
     if(tipo == 1){
       if(defecto.length > 0){
          return defecto[0].id
       }else{
          return 0
       }
     }
     if(tipo == 2){
        if(defecto.length > 0){
          return defecto[0].id
        }else{
          return lista[0].id
        }
     }
  }
  buscarId(lista, id){
    return  lista.filter(item => item.id == id)
  }
  buscarDescripcion(lista, id){
    return  lista.filter(item => item.id == id)[0].descripcion
  }
  buscarDeudor(lista, identificacion){
    if(lista == null) return false
    if(identificacion == null) return false
    let estudiante  = lista.filter(item => item.ben_cedula == identificacion)
    if(estudiante == null) return false
    if(estudiante.length == 0) return false
    if(estudiante.length > 0) return true
  }
  existe(lista, campo = null, valor = null){
    if(lista == null) return false
    if(campo == null) return false
    if(valor == null) return false
    let datos = lista.filter(item => item['campo'] == valor)
  }
}

@Injectable()
export class ActividadService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }

  arbol(idPensum, asignaturaTipo = 1, idNivel:number | null = null){
    let params ={
      token: this.LoopBackAuth.load().token,
      idPensum: idPensum,
      asignaturaTipo: asignaturaTipo,
      idNivel:idNivel,
      idPeriodo:this.LoopBackAuth.load().acaPerido.id,
    }
    console.log("arbol", JSON.stringify(params))
    return this.http.post<any>(URL+"/actividad/arbol",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('arbol', null,"shortError"))
                    )
  }
  modificarFechas(
    idActividad :String,
    fechaAperturaSecretaria :String,
    fechaCierreSecretaria : String,
    fechaAperturaDocente: String,
    fechaCierreDocente: String,
    fechaAperturaDocenteCausa:String,
    fechaCierreDocenteCausa: String){
    let params = {
      token: this.LoopBackAuth.load().token,
      idActividad: idActividad,
      fechaAperturaSecretaria:  fechaAperturaSecretaria,
      fechaCierreSecretaria: fechaCierreSecretaria,
      fechaAperturaDocente: fechaAperturaDocente,
      fechaCierreDocente: fechaCierreDocente,
      fechaAperturaDocenteCausa: fechaAperturaDocenteCausa,
      fechaCierreDocenteCausa: fechaCierreDocenteCausa
    }

    console.log("fechas actividades", JSON.stringify(params))

    return this.http.post<any>(URL+"/actividad/modificarFechas",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('actividades', null,"shortError"))
                    )
  }
  actividadesPermisos(idTipo){
    let params = {
      token: this.LoopBackAuth.load().token,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id,
      idSucursal:  this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      idJornada:this.LoopBackAuth.load().puntVenta.aca_jornada,
      idSeccion:this.LoopBackAuth.load().puntVenta.aca_seccion,
      idTipo: idTipo
    }

    console.log("permisos actividades", JSON.stringify(params))
    return this.http.post<any>(URL+"/actividad/actividadesPermisos",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('actividades', null,"shortError"))
                    )
  }

  actividadesPermisosRepresentante(){
    let params ={
      token: this.LoopBackAuth.load().token,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id,
      idSucursal:  this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      idJornada:this.LoopBackAuth.load().puntVenta.aca_jornada,
      idSeccion:this.LoopBackAuth.load().puntVenta.aca_seccion
    }
    console.log("permisos arbol", JSON.stringify(params))
    return this.http.post<any>(URL+"/actividad/actividadesPermisosRepresentante",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('arbol', null,"shortError"))
                    )
  }

  arbolAsignatura(idMatricula, tipo){
    let params ={
      token: this.LoopBackAuth.load().token,
      idMatricula: idMatricula,
      tipo: tipo
    }
    console.log("arbol", JSON.stringify(params))
    return this.http.post<any>(URL+"/actividad/arbolAsignatura",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('arbol Asignaturas', null,"shortError"))
                    )
  }
  delete(id,idPensum){
    let params ={
      token: this.LoopBackAuth.load().token,
      id:id,
      idPensum: idPensum
    }
    console.log("delete", JSON.stringify(params))
    return this.http.post<any>(URL+"/actividad/delete",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('delete', null,"shortError"))
                    )
  }
  tareaAutomatica(idPensum){
    let params ={
      token: this.LoopBackAuth.load().token,
      idPensum: idPensum
    }
    console.log("arbol", JSON.stringify(params))
    return this.http.post<any>(URL+"/actividad/tareaAutomatica",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('tareaAutomatica', null,"shortError"))
                    )
  }

  manyCreateUpdate(tareas,idPensum){
    let params ={
      token: this.LoopBackAuth.load().token,
      tareas: tareas,
      idPensum:idPensum
    }
    console.log("crear", JSON.stringify(params))
    return this.http.post<any>(URL+"/actividad/manyCreateUpdate",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('arbol', null,"shortError"))
                    )
  }
  createUpdate(nodoPadre, nodo, idPensum){
    let params ={
      token: this.LoopBackAuth.load().token,
      padre: nodoPadre,
      nodo:nodo,
      idPensum:idPensum
    }
    console.log("crear", JSON.stringify(params))
    return this.http.post<any>(URL+"/actividad/createUpdate",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('arbol', null,"shortError"))
                    )
  }
  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

@Injectable()
export class menuAccesosService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }

  menu(){
    let params ={
      token:this.LoopBackAuth.load().token,
      idPuntoVenta: this.LoopBackAuth.load().puntVenta.adm_ptoventa_id,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id
    }
    console.log("menu", JSON.stringify(params))
    return this.http.post<any>(URL+"/menu",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('menu', null,"shortError"))
                    )
  }

  dashboard(){
    let params = {
      token:this.LoopBackAuth.load().token,
    }
    return this.http.post<any>(URL+"/dashboard",params, HEADERS)
      .pipe(
        map(user => user),
        catchError( this.handleError('dashboard', null,"shortError"))
      )
  }

  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}

@Injectable()
export class reporteService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }

  libretaCalificacionPadres(link){
    return  this.http.get<any>(link)
  }

  secretariaExcelDinamicos(idReporte,nivel,especialidad,paralelo,idMatricula=0,asignatura=0,ciclo=0){
    let params ={
      token : this.LoopBackAuth.load().token,
      idReporte:idReporte,
      periodo: this.LoopBackAuth.load().acaPerido.id,
      sucursal: this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      jornada: this.LoopBackAuth.load().puntVenta.aca_jornada,
      seccion: this.LoopBackAuth.load().puntVenta.aca_seccion,
      nivel:nivel,
      especialidad:especialidad,
      paralelo:paralelo,
      asignatura: asignatura,
      idMatricula:idMatricula,
      ciclo:ciclo
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/secretariaExcelDinamicos",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }
  listaReportesPorUsuario(idReportePadre){
    let params ={
      token : this.LoopBackAuth.load().token,
      idReportePadre:idReportePadre,
      idUsuario: this.LoopBackAuth.load().user.id,
      idEmpresa: this.LoopBackAuth.load().puntVenta.adm_empresa_id,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/listaReportesPorUsuario",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }

  eliminarReportesDeRol(idReporteRol){
    let params ={
      token : this.LoopBackAuth.load().token,
      idReporte:idReporteRol,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/eliminarReportesDeRol",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }
  asignarReportesARol(idRol, idreportes){
    let params ={
      token : this.LoopBackAuth.load().token,
      idRol:idRol,
      reportes:idreportes
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/asignarReportesARol",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }

  listaReportesPorRol(idRol){
    let params ={
      token : this.LoopBackAuth.load().token,
      idRol:idRol
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/listaReportesPorRol",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }
  listaReportes(){
    let params ={
      token : this.LoopBackAuth.load().token,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/listaReportes",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }
  secretariaListadoEstudianteMatricula(nivel, especialidad, paralelo, matricula, matriculaTipo,tipoReporte){
    let params ={
      token : this.LoopBackAuth.load().token,
      periodo: this.LoopBackAuth.load().acaPerido.id,
      sucursal: this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      jornada: this.LoopBackAuth.load().puntVenta.aca_jornada,
      seccion: this.LoopBackAuth.load().puntVenta.aca_seccion,
      nivel:nivel,
      especialidad:especialidad,
      paralelo:paralelo,
      matricula: matricula,
      matriculaTipo:matriculaTipo,
      tipoReporte:tipoReporte
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/secretariaListadoEstudianteMatricula",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }
  secretariaCalificacionCalificacionPendiente(nivel, especialidad, paralelo, actividad= 2){
    let params ={
      token : this.LoopBackAuth.load().token,
      periodo: this.LoopBackAuth.load().acaPerido.id,
      sucursal: this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      jornada: this.LoopBackAuth.load().puntVenta.aca_jornada,
      seccion: this.LoopBackAuth.load().puntVenta.aca_seccion,
      nivel:nivel,
      especialidad:especialidad,
      paralelo:paralelo,
      actividad: actividad,
    }

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/secretariaCalificacionCalificacionPendiente",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }

  secretariaCalificacionCausasListadoGeneral(nivel, especialidad, paralelo, cicloParcial= 2){
    let params ={
      token : this.LoopBackAuth.load().token,
      periodo: this.LoopBackAuth.load().acaPerido.id,
      sucursal: this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      jornada: this.LoopBackAuth.load().puntVenta.aca_jornada,
      seccion: this.LoopBackAuth.load().puntVenta.aca_seccion,
      nivel:nivel,
      especialidad:especialidad,
      paralelo:paralelo,
      cicloParcial: cicloParcial,
    }

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/secretariaCalificacionCausasListadoGeneral",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }

  secretariaReportesDinamicosJava(
    nivel,
    especialidad,
    paralelo,
    asignatura,
    cicloParcial= 2,
    idMatricula = 0,
    max=0,
    min=0,
    idReporte
  ){
    let params ={
      idReporte:idReporte,
      idMatricula: idMatricula,
      periodo: this.LoopBackAuth.load().acaPerido.id,
      sucursal: this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      jornada: this.LoopBackAuth.load().puntVenta.aca_jornada,
      seccion: this.LoopBackAuth.load().puntVenta.aca_seccion,
      nivel:nivel,
      especialidad:especialidad,
      paralelo:paralelo,
      asignatura: asignatura,
      ciclo: cicloParcial,
      max: max,
      min:min,
      idUsuario: this.LoopBackAuth.load().user.id,
      tipoUsuario: 0,
    }

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL_REPORTE+"/v1/reportes/dinamico",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }

  seleccionarReportePorCurso(idCursoCompleto:number, idReporte:number,idTipo:number ){
    let params ={
      token : this.LoopBackAuth.load().token,
      idCursoCompleto: idCursoCompleto,
      idReporte:idReporte,
      idTipo:idTipo
    };

    console.log("paa:",JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/seleccionarReportePorCurso",params, HEADERS)
      .pipe(
        map(mensaje => mensaje ),
        catchError( this.handleError('Reporte', null,"shortError") )
      )
  }
  secretariaReportesDinamicos(
    nivel,
    especialidad,
    paralelo,
    asignatura,
    cicloParcial= 2,
    idMatricula = 0,
    max=0,
    min=0,
    idReporte,
    cicloFin){
    let params ={
      token : this.LoopBackAuth.load().token,
      periodo: this.LoopBackAuth.load().acaPerido.id,
      sucursal: this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      jornada: this.LoopBackAuth.load().puntVenta.aca_jornada,
      seccion: this.LoopBackAuth.load().puntVenta.aca_seccion,
      nivel:nivel,
      especialidad:especialidad,
      paralelo:paralelo,
      asignatura: asignatura,
      ciclo: cicloParcial,
      idReporte:idReporte,
      idMatricula: idMatricula,
      max: max,
      min:min,
      cicloFin:cicloFin
    }

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/secretariaReportesDinamicos",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }

  secretariaCalificacionCausasPorAsignatura(nivel, especialidad, paralelo, asignatura, cicloParcial= 2){
    let params ={
      token : this.LoopBackAuth.load().token,
      periodo: this.LoopBackAuth.load().acaPerido.id,
      sucursal: this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      jornada: this.LoopBackAuth.load().puntVenta.aca_jornada,
      seccion: this.LoopBackAuth.load().puntVenta.aca_seccion,
      nivel:nivel,
      especialidad:especialidad,
      paralelo:paralelo,
      asignatura: asignatura,
      ciclo: cicloParcial,
    }

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/reporte/secretariaCalificacionCausasPorAsignatura",params, HEADERS)
    .pipe(
      map(mensaje => mensaje ),
      catchError( this.handleError('Reporte', null,"shortError") )
    )
  }

  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}

@Injectable()
export class causasService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }
  createUpdate(idCalificacion,idCausas, sugerencia){
    let params = {
      token:this.LoopBackAuth.load().token,
      idCalificacion:idCalificacion,
      idCausas:idCausas,
      sugerencia:sugerencia,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/causa/createUpdate",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('Crear', null,"shortError") )
                    )
  }
  searchCalificacion(idCalificacion){
    let params = {
      token:this.LoopBackAuth.load().token,
      idCalificacion:idCalificacion,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/causa/searchCalificacion",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista', null,"shortError") )
                    )
  }

  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}


@Injectable()
export class calificacionService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }

  horasMateriasDia(idPensum){
    let params = {
      token:this.LoopBackAuth.load().token,
      idPensum: idPensum
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asistencia/horasMateriasDia",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )

  }
  configuracionPorNive(idNivel){
    let params = {
      token:this.LoopBackAuth.load().token,
      idNivel: idNivel,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asistencia/configuracionPorNivel",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )
  }
  cambioDeParaleloEstudiante(
    idMatricula: any,
    cursoCompletoAntiguo: any,
    cursoCompletoNuevo: any){
    let params = {
      token:this.LoopBackAuth.load().token,
      idMatricula:idMatricula,
      cursoCompletoAntiguo: cursoCompletoAntiguo,
      cursoCompletoNuevo: cursoCompletoNuevo,
      idUsuario: this.LoopBackAuth.load().user.id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/calificacion/cambioDeParaleloEstudiante",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )
  }
  tieneCalificaciones(idMatricula: any){
    let params = {
      token:this.LoopBackAuth.load().token,
      idMatricula:idMatricula,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/calificacion/tieneCalificaciones",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )
  }

  calificacionAsignatura(idMatricula, tipo){
    let params = {
      token:this.LoopBackAuth.load().token,
      idMatricula:idMatricula,
      tipo:tipo
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/calificacion/calificacionAsignatura",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )
  }

  tareasCalificacionesPadres(idActividad, idPensum, idTipo, idMatricula){
    let params = {
      token:this.LoopBackAuth.load().token,
      idMatricula:idMatricula,
      idTipo:idTipo,
      idTareaPadre:idActividad,
      idPensum:idPensum
    }

    return this.http.post<any>(URL+"/calificacion/tareasCalificacionesPadres",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista', null,"shortError") )
                    )
  }

  recalcularNotasCurso(idPensum, idMatricula,idActividad){
    let params = {
      token:this.LoopBackAuth.load().token,
      idPensum:idPensum,
      idMatricula:idMatricula,
      idActividad:idActividad,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/calificacion/recalcularNotasCurso",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )
  }

  asignarCalificacionEstudianteMateria(
    idPensum : any,
    idMatricula : any,
    idActividad : any,
    idCalificacion : any,
    nota: any = 0,
    observacion : any = null,
    asistenciaPeriodo : any = null){
    let params = {
      token:this.LoopBackAuth.load().token,
      idPensum:idPensum,
      idMatricula:idMatricula,
      idActividad:idActividad,
      idCalificacion:idCalificacion,
      nota:nota,
      observacion: observacion,
      asistenciaPeriodo:asistenciaPeriodo
    }
    console.log("Hola mundo PP -->",JSON.stringify(params))
    return this.http.post<any>(URL+"/calificacion/asignarCalificacionEstudianteMateria",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )
  }
  calificacionPensum(idPensum, idAsignaturaTipo = 1,idNivel:number| null =null ){
    let params = {
      token:this.LoopBackAuth.load().token,
      idPensum:idPensum,
      idAsignaturaTipo: idAsignaturaTipo,
      idNivel:idNivel,
      idPeriodo:this.LoopBackAuth.load().acaPerido.id,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/calificacion/calificacionPensum",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista', null,"shortError") )
                    )
  }
  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

@Injectable()
export class horarioService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }

  deleteHorarioAsignatura(id){
    let params = {
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/horario/deleteHorarioAsignatura",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('delete', null,"shortError") )
                    )
  }

  asignarHorarioAsignatura(item){
    let params = {
      token:this.LoopBackAuth.load().token,
      item
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/horario/asignarHorarioAsignatura",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('asignar', null,"shortError") )
                    )
  }
  findHoras(idCursoCompleto){
    let params = {
      token:this.LoopBackAuth.load().token,
      idCursoCompleto:idCursoCompleto,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/horario/findHoras",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista', null,"shortError") )
                    )
  }

  findDias(){
    let params = {
      token:this.LoopBackAuth.load().token,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/horario/findDias",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista', null,"shortError") )
                    )
  }

  findAsignaturas(idCursoCompleto){
    let params = {
      token:this.LoopBackAuth.load().token,
      idCursoCompleto:idCursoCompleto,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/horario/findAsignaturas",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista', null,"shortError") )
                    )
  }

  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}

@Injectable()
export class pensumService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }
  asignaturasPensum(idMatricula, tipoAsignatura){
    let params = {
      token:this.LoopBackAuth.load().token,
      idMatricula:idMatricula,
      tipoAsignatura: tipoAsignatura
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/pensum/asignaturasPensum",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista', null,"shortError") )
                    )
  }
  estudiantesPensum(idPensum){
    let params = {
      token:this.LoopBackAuth.load().token,
      idPensum:idPensum,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/pensum/estudiantesPensum",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista', null,"shortError") )
                    )
  }

  validarPensumTieneCalificaciones(idPensum){
    let params = {
      token:this.LoopBackAuth.load().token,
      idPensum:idPensum,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/pensum/validarPensumTieneCalificaciones",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('validacion', null,"shortError") )
                    )
  }

  asignarInsumos(orden, idPensum){
    let params = {
      token:this.LoopBackAuth.load().token,
      idPensum:idPensum,
      orden:orden
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/pensum/asignarInsumos",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('asiganr', null,"shortError") )
                    )
  }

  create(items){
    let params ={
      token:this.LoopBackAuth.load().token,
      id: items.id,
      curso: items.curso,
      materia: items.materia,
      docente: items.docente,
      estado: items.estado,
      activarActividades: items.activarActividades,
      orden: items.orden,
      formula: items.formula,
      cuantitativa: items.cuantitativa,
      imprimir: items.imprimir,
      ministerio: items.ministerio,
      actividad: items.actividad
    }

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/pensum/createUpdate",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )
  }

  asignaturasDocente(idUsuario = 0, idCursoCumpleto = 0){
    let params = {
      token:this.LoopBackAuth.load().token,
      cursoCompleto:idCursoCumpleto,
      idUsuario: idUsuario,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/pensum/asignaturasDocente",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista', null,"shortError") )
                    )
  }

  delete(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/pensum/delete",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('eliminar', null,"shortError") )
                    )
  }

  searchCursoCompleto(curso){
    let params ={
      token:this.LoopBackAuth.load().token,
      cursoCompleto: curso
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/pensum/searchCursoCompleto",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar lineas', null,"shortError") )
                    )
  }

  find(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log("find docentes",JSON.stringify(params))
    return this.http.post<any>(URL+"/pensum/find",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('item', null,"shortError") )
                    )
  }

  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

@Injectable()
export class docenteService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }

  create(items){
    let params ={
      token:this.LoopBackAuth.load().token,
      puntoVentaId: this.LoopBackAuth.load().puntVenta.adm_ptoventa_id,
      items
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/docente/createUpdate",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )
  }

  findIdentificacion(identificacion){
    let params ={identificacion:identificacion,token:this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/docente/findIdentificacion",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('findIdentificacion', null,"shortError") )
                    )
  }

  listaTutores(){
    let params ={token:this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/docente/listaTutores",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista de ttores', null,"shortError") )
                    )
  }

  delete(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/docente/delete",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('eliminar', null,"shortError") )
                    )
  }
  searchUsuario(idUsuario){
    let params ={
      token:this.LoopBackAuth.load().token,
      idUsuario:idUsuario
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/docente/searchUsuario",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('item', null,"shortError") )
                    )
  }

  search(){
    let params ={
      token:this.LoopBackAuth.load().token,
      acaPeriodo: this.LoopBackAuth.load().acaPerido.id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/docente/search",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar lineas', null,"shortError") )
                    )
  }

  find(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log("find docentes",JSON.stringify(params))
    return this.http.post<any>(URL+"/docente/find",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('item', null,"shortError") )
                    )
  }

  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}

@Injectable()
export class asignaturaAreaService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }
  create(items){
    let params ={
      token:this.LoopBackAuth.load().token,
      id: items.id,
      descripcion: items.descripcion,
      estado: items.estado,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id,
      ordenPrimaria: items.ordenPrimaria,
      ordenSecundaria: items.ordenSecundaria
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asignaturarea/createUpdate",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )
  }

  validarAsignacionAsignatura(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asignaturarea/validarAsignacionAsignatura",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('validar', null,"shortError") )
                    )
  }

  delete(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asignaturarea/delete",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('eliminar', null,"shortError") )
                    )
  }

  listaActivas(){
    let params ={
      token:this.LoopBackAuth.load().token,
    }
    console.log(JSON.stringify(params),"---->")
    return this.http.post<any>(URL+"/asignaturarea/listaActivas",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar lineas', null,"shortError") )
                    )
  }
  search(){
    let params ={
      token:this.LoopBackAuth.load().token,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id,
    }
    console.log(JSON.stringify(params),"PPP")
    return this.http.post<any>(URL+"/asignaturarea/search",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar lineas', null,"shortError") )
                    )
  }

  find(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asignaturarea/find",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('item', null,"shortError") )
                    )
  }
  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}


@Injectable()
export class asignaturaService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }

  activarVisualizacionCalificacionesImpresion(id,cicloParcialPeriodo,aperturaVisualizacion,aperturaImpresion){
    let params ={
      token:this.LoopBackAuth.load().token,
      cicloParcialPeriodo:cicloParcialPeriodo,
      aperturaVisualizacion:aperturaVisualizacion,
      aperturaImpresion:aperturaImpresion,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asignatura/activarVisualizacionCalificacionesImpresion",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('crear permisos calificacion', null,"shortError") )
                    )
  }

  asignarTutor(idCursoCompleto, idTutor){
    let params ={
      token:this.LoopBackAuth.load().token,
      idCursoCompleto:idCursoCompleto,
      idUsuario:idTutor
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asignatura/asignarTutor",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('crear tutor', null,"shortError") )
                    )
  }

  create(item){
    let params ={
      token:this.LoopBackAuth.load().token,
      id: item.id,
      descripcion: item.descripcion,
      estado: item.estado,
      area: item.area,
      color:item.color,
      decimales: item.decimales,
      asistenciatipo: item.asistenciatipo,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asignatura/createUpdate",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )
  }

  validarAsignacionPensum(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asignatura/validarAsignacionPensum",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('validar', null,"shortError") )
                    )
  }

  listaActivas(){
    let params ={
      token:this.LoopBackAuth.load().token,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asignatura/listaActivas",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar lineas', null,"shortError") )
                    )
  }

  delete(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asignatura/delete",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('eliminar', null,"shortError") )
                    )
  }
  search(){
    let params ={
      token:this.LoopBackAuth.load().token,
    }
    console.log("hojo",JSON.stringify(params))
    return this.http.post<any>(URL+"/asignatura/search",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar lineas', null,"shortError") )
                    )
  }
  find(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/asignatura/find",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('item', null,"shortError") )
                    )
  }
  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

@Injectable()
export class transporteService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }
  searchTransporteMatricula(items){
    let params = {
      token: this.LoopBackAuth.load().token,
      nombre:(items.nombre !== undefined && items.nombre != null)? String(items.nombre).toUpperCase() :null,
      identificacion:(items.identificacion !== undefined)? items.identificacion: null,
      acaPeriodo:this.LoopBackAuth.load().acaPerido.id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/transporte/searchTransporteMatricula",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscador', null,"shortError") )
                    )
  }

  searchLineas(){
    let params ={
      token:this.LoopBackAuth.load().token,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/transporte/searchLineas",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar lineas', null,"shortError") )
                    )
  }
  findTransporteMatricula(idMatricula){
    let params ={
      token:this.LoopBackAuth.load().token,
      idMatricula:idMatricula
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/transporte/findTransporteMatricula",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar por  matricula', null,"shortError") )
                    )
  }
  createUpdateTransporteMatricula(items){
    let params ={
      token:this.LoopBackAuth.load().token,
      items
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/transporte/createUpdateTransporteMatricula",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar por  matricula', null,"shortError") )
                    )
  }

  deleteTransporteMatricula(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/transporte/deleteTransporteMatricula",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar por  matricula', null,"shortError") )
                    )
  }

  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

@Injectable()
export class estudianteService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }

  findIdentificacion(identificacion){
    let params ={identificacion:identificacion,token:this.LoopBackAuth.load().token, idPeriodo: this.LoopBackAuth.load().acaPerido.id}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/estudiante/findIdentificacion",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('findIdentificacion', null,"shortError") )
                    )
  }
  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

@Injectable()
export class rolesService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }
  eliminarRolesUsuario(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/role/eliminarRolesUsuario",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista roles por usuario', null,"shortError") )
                    )
  }

  asignarRolesUsuario(idUsuario, idPVenta, idRol, idJornada, idSeccion){
    let params ={
      token:this.LoopBackAuth.load().token,
      idUsuario:idUsuario,
      idRol:idRol,
      idPVenta:idPVenta,
      idJornada:idJornada,
      idSeccion:idSeccion
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/role/asignarRolesUsuario",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista roles por usuario', null,"shortError") )
                    )
  }
  rolesPorUsuario(id){
    let params ={
      token:this.LoopBackAuth.load().token,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/role/rolesPorUsuario",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('lista roles por usuario', null,"shortError") )
                    )
  }

  search(){
    let params ={
      token:this.LoopBackAuth.load().token
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/role/search",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('findIdentificacion', null,"shortError") )
                    )
  }
  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

@Injectable()
export class listadosService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }
  gridByIdPadreAndIdPeriodo(idPadre:number){
    let params = {
      token: this.LoopBackAuth.load().token,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id,
      idPadre:idPadre
    }
    console.log("Datos grid -->", JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/gridByIdPadreAndIdPeriodo",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Grid', null,"shortError"))
                    )
  }
  listaAsignaturaTipo(){
    let params = {token: this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/listaAsignaturaTipo",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }
  roles(){
    let params = {token: this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/roles",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }

  guardarCamposSeleccionadosExcel(campos: any){
    let params = {
      token: this.LoopBackAuth.load().token,
      campos: campos
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/guardarCamposSeleccionadosExcel",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }

  listaCamposExcelReporte(idReporte){
    let params = {
      token: this.LoopBackAuth.load().token,
      idReporte: idReporte
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/listaCamposExcelReporte",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }

  listaAsistenciaTipo(){
    let params = {
      token: this.LoopBackAuth.load().token,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/listaAsistenciaTipo",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }


  empresaSucursal(){
    let params = {token: this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/empresaSucursal",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }
  tiposParentesco(){
    let params = {token: this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/tiposParentesco",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }
  estados(){
    let params = {token: this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/estados",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }
  cuentasPorCobrarEstudiante(){
    let params = {token: this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params));
    return this.http.post<any>(URL+"/listas/cuentasPorCobrarEstudiante",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }

  estadoCuentaEstudiante(identificacion){
    let params = {
      token: this.LoopBackAuth.load().token,
      identificacion: identificacion
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/estadoCuentaEstudiante",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }

  facturaElectronicaEstudiante(identificacion){
    let params = {
      token: this.LoopBackAuth.load().token,
      identificacion: identificacion
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/facturaElectronicaEstudiante",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }

  tieneDeudasEstudiante(identificacion){
    let params = {
      token: this.LoopBackAuth.load().token,
      identificacion: identificacion
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/tieneDeudasEstudiante",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }
  categoriasParentesco(){
    let params = {token: this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/categoriasParentesco",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }

  descuentosActivos(){
    let params = {token: this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/descuentosActivos",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }

  grupos(grupos : String){
    let params = {token: this.LoopBackAuth.load().token, grupos: grupos}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/grupos",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }
  provincias(){
    let params = {token: this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/provincias",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }

  identificaciones(transaccion = 2){
    let params = {token: this.LoopBackAuth.load().token,trasaccion:transaccion}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/identificaciones",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }


  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
@Injectable()
export class encuestaService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }
  find(idEncuesta, idMatricula){
    let params ={
      idEncuesta:idEncuesta,
      idMatricula:idMatricula,
      token:this.LoopBackAuth.load().token
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/encuesta/find",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('find', null,"shortError") )
                    )
  }
  createUpdate(idEncuesta, idMatricula, items){
    let params ={
      idEncuesta:idEncuesta,
      idMatricula:idMatricula,
      encuesta: items,
      token:this.LoopBackAuth.load().token
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/encuesta/createUpdate",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('create', null,"shortError") )
                    )
  }
  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
@Injectable()
export class contactosService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }
  findUsuarioId(usuario){
    let params ={id:usuario,token:this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/contactos/findUsuarioId",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar', null,"shortError") )
                    )
  }

  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

@Injectable()
export class parienteService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }


  modificarCorreoElectronico(id, correo){
    let params ={
      id:id,
      correo:correo,
      token:this.LoopBackAuth.load().token}

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/parentesco/modificarCorreoElectronico",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar', null,"shortError") )
                    )
  }
  representanteEconomico(id){
    let params ={
      id:id,
      token:this.LoopBackAuth.load().token}

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/parentesco/representanteEconomico",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar', null,"shortError") )
                    )
  }

  findIdentificacion(identificacion , idEstudiante){
    let params ={
      identificacion:identificacion,
      idEstudiante:idEstudiante,
      token:this.LoopBackAuth.load().token}

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/parentesco/findIdentificacion",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar', null,"shortError") )
                    )
  }

  checkCategorias(idEstudiante, idPariente, idCategoria, accion = true){
    let params ={
      token:this.LoopBackAuth.load().token,
      idEstudiante:idEstudiante,
      idPariente:idPariente,
      idCategoria:idCategoria,
      accion: accion
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/parentesco/asignarCategorias",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar', null,"shortError") )
                    )
  }

  findUsuarioId(usuario){
    let params ={id:usuario,token:this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/contactos/findUsuarioId",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('buscar', null,"shortError") )
                    )
  }
  createMany(idEstudiante, list){
    let params = {
      token: this.LoopBackAuth.load().token,
      id:idEstudiante,
      puntoVentaId: this.LoopBackAuth.load().puntVenta.adm_ptoventa_id,
      lista: list
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/parentesco/createMany",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('List Crear', null,"shortError"))
                    )
  }
  create(idEstudiante, item){
    let params = {
      token: this.LoopBackAuth.load().token,
      id:idEstudiante,
      puntoVentaId: this.LoopBackAuth.load().puntVenta.adm_ptoventa_id,
      item: item
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/parentesco/create",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Crear', null,"shortError"))
                    )
  }

  delete(idEstudiante, id){
    let params = {
      token: this.LoopBackAuth.load().token,
      idEstudiante:idEstudiante,
      id:id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/parentesco/delete",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }

  search(idEstudiante){
    let params = {
      token: this.LoopBackAuth.load().token,
      id:idEstudiante
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/parentesco/search",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Listado', null,"shortError"))
                    )
  }
  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
@Injectable()
export class matriculaService{
  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }


  getDatosEstudiateMatriculadoPorPeriodo(){
    let params = {
      token: this.LoopBackAuth.load().token,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id
      }

    console.log("Datos Estudiane Por periodo -->",JSON.stringify(param))
    return this.http.post<any>(URL+"/matricula/datosEstudiateMatriculadoPorPeriodo",params, HEADERS)
      .pipe(
        map(user => user),
        catchError( this.handleError('Datos estudiante Periodo', null,"shortError"))
      )
  }

  create(item){
    let params = {
      token: this.LoopBackAuth.load().token,
      acaPeriodo:this.LoopBackAuth.load().acaPerido.id,
      puntoVentaId: this.LoopBackAuth.load().puntVenta.adm_ptoventa_id,
      item }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/create",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Crear', null,"shortError"))
                    )
  }

  findUsuario(idUsuario){
    let params = {
      token: this.LoopBackAuth.load().token,
      idUsuario: idUsuario,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/findUsuario",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('idMatricula', null,"shortError"))
                    )
  }

  alumnosPaseAnio(idNuevoPeriodo:any, cursocompleto:any,alumnos:any){
    let params = {
      token: this.LoopBackAuth.load().token,
      idPeriodo: idNuevoPeriodo,
      idCursoCompleto: cursocompleto,
      idAlumnos : alumnos
    }

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/paseAnioAluninos",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('idMatricula', null,"shortError"))
                    )
  }

  serachAlumnosPaseAnio(nivel:any,especialidad:any,paralelo:any, idNuevoPeriodo){
    let params = {
      token: this.LoopBackAuth.load().token,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id,
      idNuevoPeriodo : idNuevoPeriodo,
      idSucursal: this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      idJornada: this.LoopBackAuth.load().puntVenta.aca_jornada,
      idSeccion: this.LoopBackAuth.load().puntVenta.aca_seccion,
      nivel: nivel,
      especialidad: especialidad,
      paralelo: paralelo
    }

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/serachAlumnosPaseAnio",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('idMatricula', null,"shortError"))
                    )
  }

  asignarCursoCompleto(items){
    let params = {
      token: this.LoopBackAuth.load().token,
      items: items
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/asignarCursoCompleto",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('asiganar', null,"shortError"))
                    )
  }

  searchCursoPorNivel(nivel, tipoActivacion = 1, especialidad =null, paralelo = null, idPeriodo = null){
    let params = {
      token: this.LoopBackAuth.load().token,
      periodoId: isNull(idPeriodo) ? this.LoopBackAuth.load().acaPerido.id : idPeriodo,
      sucursalId: this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      jornadaId: 1,
      seccionId: 1,
      nivel: nivel,
      especialidad: especialidad,
      paralelo: paralelo,
      tipoActivacion:tipoActivacion
    }
    console.log("curso por nivel",JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/searchCursosPorNivel",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('lista', null,"shortError"))
                    )
  }

  searchAlumnosMatriculados(nivel, especialidad =null, paralelo = null){
    let params = {
      token: this.LoopBackAuth.load().token,
      periodoId:this.LoopBackAuth.load().acaPerido.id,
      sucursalId: this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      jornadaId: 1,
      seccionId: 1,
      nivel: nivel,
      especialidad: especialidad,
      paralelo: paralelo
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/searchAlumnosMatriculados",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('lista', null,"shortError"))
                    )
  }

  asignarBeca(idMatricula, idBeca){
    let params = {
      token: this.LoopBackAuth.load().token,
      matricula: idMatricula,
      beca:idBeca
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/asignarBeca",params, HEADERS)
                    .pipe(
                      map(current => current),
                      catchError( this.handleError('lista', null,"shortError") )
                    )
  }

  documentos(){
    let params = {
      token: this.LoopBackAuth.load().token,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/documentos/search",params, HEADERS)
                    .pipe(
                      map(current => current),
                      catchError( this.handleError('lista', null,"shortError") )
                    )
  }

  getDocumentoSolicitado(){
    let params = {
      token: this.LoopBackAuth.load().token,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/documentos/searchDocumentoSolicitado",params, HEADERS)
                    .pipe(
                      map(current => current),
                      catchError( this.handleError('documentosSolicitado', null,"shortError") )
                    )
  }

  getDocumentoSolicitadoPorMatricula(idMatricula:number){
    let params = {
      token: this.LoopBackAuth.load().token,
      idMatricula: idMatricula
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/documentos/documentoSolicitadoPorMatricula",params, HEADERS)
                    .pipe(
                      map(current => current),
                      catchError( this.handleError('documentosSolicitadoPorMatricula', null,"shortError") )
                    )
  }

  public createUpdateDocumentoSolicitado(idMatricula:number, documentoSolicitado:any[]){
    let params = {
      token: this.LoopBackAuth.load().token,
      idMatricula: idMatricula,
      documentoSolicitado:documentoSolicitado
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/documentos/createUpdateDocumentoSolicitado",params, HEADERS)
                    .pipe(
                      map(current => current),
                      catchError( this.handleError('createUpdateDocumentoSolicitado', null,"shortError") )
                    )
  }



  autorizarColecturuaMatricula(idMatricula,items){
    let params = {
      token: this.LoopBackAuth.load().token,
      idMatricula: idMatricula,
      items
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/autorizacionColecturiaMatricula",params, HEADERS)
                    .pipe(
                      map(current => current),
                      catchError( this.handleError('autorizacion', null,"shortError") )
                    )
  }

  search(items){
    let params = {
      token: this.LoopBackAuth.load().token,
      nombre:(items.nombre !== undefined && items.nombre!= null)?  String(items.nombre).toUpperCase()  :null, //
      identificacion:(items.identificacion !== undefined)? items.identificacion: null,
      nivel: (items.nivel !== undefined)? items.nivel : null,
      acaPeriodo:this.LoopBackAuth.load().acaPerido.id
    }
    return this.http.post<any>(URL+"/matricula/search",params, HEADERS)
                    .pipe(
                      map(current => current),
                      catchError( this.handleError('login', null,"shortError") )
                    )
  }

  /** Start */
  //** Busscar los productos que corresponden a Transporte y Extracurriculares */
  setProductoMatricula(idProductoMatricula, idMatricula, idProducto, valor, orden, idEstado, idUsuario) {

    let params = {
      token: this.LoopBackAuth.load().token,
      idProductoMatricula: idProductoMatricula,
      idMatricula: idMatricula,
      idProducto: idProducto,
      valor: valor,
      orden: orden,
      idEstado: idEstado,
      idUsuario: idUsuario
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL + "/transporte/createUpdateProductoMatricula", params, HEADERS)
      .pipe(
        map(matricula => matricula),
        catchError(this.handleError('find', null, "shortError"))
      )
  }
  setProducto(idProducto, idTipo, descripcion, valor, orden, idEstado,idUsuario ) {

    let params = {
      token: this.LoopBackAuth.load().token,
      idProducto: idProducto,
      idTipo: idTipo,
      descripcion: descripcion,
      valor: valor,
      orden: orden,
      idEstado: idEstado,
      idUsuario: idUsuario,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL + "/transporte/createUpdateProducto", params, HEADERS)
      .pipe(
        map(matricula => matricula),
        catchError(this.handleError('find', null, "shortError"))
      )
  }

  asignarDeuda(alumno:any){
    let params ={
      token: this.LoopBackAuth.load().token,
      identificacion:alumno.identificacion,
      nombre:alumno.apellido+" "+alumno.nombre,
      valor:alumno.adeuda ? 1 :0
    }
    console.log("parametros -->", params)
    return this.http.post<any>(URL + "/matricula/bloquearAccesoAlumno", params, HEADERS);
  }
  searchProducto(transporte) {

    let params = {
      token: this.LoopBackAuth.load().token,
      transporte: transporte
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL + "/transporte/searchProducto", params, HEADERS)
      .pipe(
        map(matricula => matricula),
        catchError(this.handleError('find', null, "shortError"))
      )
  }

  searchProductoMatriculado(idMatricula, idTipo) {

    let params = {
      token: this.LoopBackAuth.load().token,
      matricula: idMatricula,
      tipo: idTipo
    }

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL + "/transporte/searchProductoMatricula", params, HEADERS)
      .pipe(
        map(matricula => matricula),
        catchError(this.handleError('find', null, "shortError"))
      )
  }

  deleteProductoMatriculado(idProductoMatricula, idUsuario) {

    let params = {
      token: this.LoopBackAuth.load().token,
      idProductoMatricula: idProductoMatricula,
      idUsuario: idUsuario,

    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL + "/transporte/deleteProductoMatricula", params, HEADERS)
      .pipe(
        map(matricula => matricula),
        catchError(this.handleError('eliminar', null, "shortError"))
      )

  }
  deleteProducto(idProducto, idUsuario) {

    let params = {
      token: this.LoopBackAuth.load().token,
      idProducto: idProducto,
      idUsuario: idUsuario,

    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL + "/transporte/deleteProducto", params, HEADERS)
      .pipe(
        map(matricula => matricula),
        catchError(this.handleError('eliminar', null, "shortError"))
      )

  }

  /** END  */

  find(id){
    let params = {token: this.LoopBackAuth.load().token,id:id}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/find",params, HEADERS)
                    .pipe(
                      map(matricula => matricula),
                      catchError( this.handleError('find', null,"shortError"))
                    )
  }

  delete(id){
    let params = {token: this.LoopBackAuth.load().token,id:id}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/delete",params, HEADERS)
                    .pipe(
                      map(matricula => matricula),
                      catchError( this.handleError('eliminar', null,"shortError"))
                    )
  }

  update(item){
    let params = {
      token: this.LoopBackAuth.load().token,
      acaPeriodo:this.LoopBackAuth.load().acaPerido.id,
      item }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/update",params, HEADERS)
                    .pipe(
                      map(matricula => matricula),
                      catchError( this.handleError('Modificar', null,"shortError"))
                    )
  }

  statusChange(idMatricula, idEstado){
    let params = {
      token: this.LoopBackAuth.load().token,
      idMatricula:idMatricula,
      idEstado: idEstado }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/statusChange",params, HEADERS)
                    .pipe(
                      map(matricula => matricula),
                      catchError( this.handleError('Cambiar Estado', null,"shortError"))
                    )
  }

  importarFotos(imagenes:any){
    let params = {
      token: this.LoopBackAuth.load().token,
      fotos:imagenes,
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/importarFotos",params, HEADERS)
                    .pipe(
                      map(matricula => matricula),
                      catchError( this.handleError('Cambiar Estado', null,"shortError"))
                    )
  }

  listaEstudiantesImportarFoto(nivel:string,especialidad:string,paralelo:string){
    let params = {
      token: this.LoopBackAuth.load().token,
      idPeriodo: this.LoopBackAuth.load().acaPerido.id,
      idSucursal: this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      idJornada: this.LoopBackAuth.load().puntVenta.aca_jornada,
      idSeccion: this.LoopBackAuth.load().puntVenta.aca_seccion,
      nivel: nivel,
      especialidad: especialidad,
      paralelo: paralelo
    }

    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/matricula/listaEstudiantesImportarFotos",params, HEADERS)
                    .pipe(
                      map(matricula => matricula),
                      catchError( this.handleError('Cambiar Estado', null,"shortError"))
                    )
  }
  /** Servicios para la busqueda de datos de combox */
  listasCursos(tipo = 'nivel',tipoActivacion = 1, idPeriodo =  null, nivel = null,especialidad = null){
    let params = {
      token: this.LoopBackAuth.load().token,
      acaPeriodo: isNull(idPeriodo) ? this.LoopBackAuth.load().acaPerido.id :idPeriodo,
      sucursal:this.LoopBackAuth.load().puntVenta.adm_sucursal_id,
      cursoJornada:this.LoopBackAuth.load().puntVenta.aca_jornada,
      cursoSeccion:this.LoopBackAuth.load().puntVenta.aca_seccion,
      tipo:tipo,
      nivel:nivel,
      especialidad:especialidad,
      tipoActivacion:tipoActivacion
    }
    console.log("niveles--->",JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/listaDatosCursos",params, HEADERS)
                    .pipe(
                      map(lista => lista),
                      catchError( this.handleError('Listar', null,"shortError"))
                    )
  }
  listasCombox(transaccion = 2, grupos){
    let params = {
      token: this.LoopBackAuth.load().token,
      trasaccion:transaccion,
      grupos:grupos
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/listas/listasAcademico",params, HEADERS)
                    .pipe(
                      map(lista => lista),
                      catchError( this.handleError('Listar', null,"shortError"))
                    )
  }

  textoPantallaPrincipalEstudiante(idEstudiante:number, idTipoPantalla: number){
    return this.http.get<any>(URL+"/matricula/textoPantallaPrincipalEstudiante/"+idEstudiante+"/"+idTipoPantalla)
                    .pipe(
                      map(lista => lista),
                      catchError( this.handleError('Listar', null,"shortError"))
                    )
  }

  buscarSiAlumnoLLenoEncuesta(idMatricula:number,idEncuesta:number){
    return this.http.get<any>(URL+"/matricula/buscarSiAlumnoLLenoEncuesta/"+idEncuesta+"/"+idMatricula)
                    .pipe(
                      map(lista => lista),
                      catchError( this.handleError('Listar', null,"shortError"))
                    )
  }

  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        this.message.shortError(error.error)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

@Injectable()
export class userService{

  constructor(private http: HttpClient, private message: MessageService , private LoopBackAuth :  LoopBackAuth){ }

  validarFechaVersion(){
    let params = {
      token: this.LoopBackAuth.load().token
    }
    console.log("validarFechaVersion", JSON.stringify(params))
    return this.http.post<any>(URL+"/validarFechaVersion",params, HEADERS)
                    .pipe(
                      tap(current => current ),
                      catchError( this.handleError('validar version', null,"largeError") )
                    )
  }
  login(user:string, password:string):Observable<any>{
    let params = {user:user,password:password}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/login",params, HEADERS)
                    .pipe(
                      tap(current =>{
                        localStorage.setItem('LoopBackAuth', JSON.stringify(current))
                      } ),
                      catchError( this.handleError('login', null,"largeError") )
                    )

  }


  logout(){
    let params = {token: this.LoopBackAuth.load().token}
    console.log("recover", JSON.stringify(params))
    return this.http.post<any>(URL+"/logout",params, HEADERS)
                    .pipe(
                      tap(current => current ),
                      catchError( this.handleError('login', null,"largeError") )
                    )
  }

  verificarClaveAnterior(contrasenia:string){
    let params = {
      token: this.LoopBackAuth.load().token,
      contrasenia:contrasenia
    }
    console.log("verificarClaveAnterior", JSON.stringify(params))
    return this.http.post<any>(URL+"/user/verificarClaveAnterior",params, HEADERS)
                    .pipe(
                      tap(current => current ),
                      catchError( this.handleError('login', null,"largeError") )
                    )
  }

  cambioUserName(userName:string){
    let params = {
      token: this.LoopBackAuth.load().token,
      userName:userName
    }
    console.log("recover", JSON.stringify(params))
    return this.http.post<any>(URL+"/user/cambioUserName",params, HEADERS)
                    .pipe(
                      tap(current => current ),
                      catchError( this.handleError('login', null,"shortError") )
                    )
  }

  recoverKey(user){
    let params ={usuario:user}
    console.log("recover",params)
    return this.http.post<any>(URL+"/recoverPassword",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('recover', null,"largeError") )
                    )
  }

  changePassword(contrasenia,nuevaContrasenia){
    let params ={contrasenia:contrasenia,nuevaContrasenia:nuevaContrasenia,token:this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/user/changePassword",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('changePassword', null,"largeError") )
                    )
  }

  resetPassword(id){
    let params ={id:id,token:this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/user/resetPassword",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('resetPassword', null,"largeError") )
                    )
  }

  findIdentificacion(identificacion){
    let params ={identificacion:identificacion,token:this.LoopBackAuth.load().token}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/user/findIdentificacion",params, HEADERS)
                    .pipe(
                      map(mensaje => mensaje ),
                      catchError( this.handleError('resetPassword', null,"shortError") )
                    )
  }

  delete(id){
    let params = {token: this.LoopBackAuth.load().token,id:id}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/user/delete",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('login', null,"shortError"))
                    )
  }

  update(item){
    let params = {
      token: this.LoopBackAuth.load().token,
      puntoVentaId: this.LoopBackAuth.load().puntVenta.adm_ptoventa_id,
      item:item
    }
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/user/update",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Modificar', null,"shortError"))
                    )
  }
  create(item){
    let params = {
      token: this.LoopBackAuth.load().token,
      puntoVentaId: this.LoopBackAuth.load().puntVenta.adm_ptoventa_id,
      item:item}
    console.log(JSON.stringify(params))
    return this.http.post<any>(URL+"/user/create",params, HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Crear', null,"shortError"))
                    )
  }

  upload(file, id){
    let params = {token: this.LoopBackAuth.load().token,id:id,modulo:'usuarios',image:file}
    return this.http.post<any>(URL+"/uploadImagen",params,HEADERS)
                    .pipe(
                      map(user => user),
                      catchError( this.handleError('Subir Imagen', null,"shortError"))
                    )
  }
  search(esUsuario){
    let params = {
      token: this.LoopBackAuth.load().token,
      esUsuario: esUsuario
    }
    console.log("search user -->",JSON.stringify(params))
    return this.http.post<any>(URL+"/user/search",params, HEADERS)
                    .pipe(
                      map(current => current),
                      catchError( this.handleError('login', null,"shortError") )
                    )
  }



  private handleError<T> (operation = 'operation', result?: T,tipo = 'shortError') {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error('error-->',error); // log to console instead
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
      if(tipo ==='shortError'){
        let mensaje = isNull(result) ?  error.error : result
        this.message.shortError(mensaje)
      }
      if(tipo ==='largeError'){
        this.message.largeError(error.error)
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /*private log(message: string) {

  }*/
}









// WEBPACK FOOTER //
// ./src/app/shared/services/api-rest.service.ts